import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from '@material-ui/lab'

const Loader = ({ className = '' }) => {
  return (
    <div className={className}>
      <div className="flex space-x-2">
        <Skeleton animation="wave" variant="circle" className="w-40 h-40" />
        <div className="w-5/6">
          <Skeleton animation="wave" variant="text" className="w-256" />
          <Skeleton animation="wave" variant="text" className="w-256" />
        </div>
      </div>
      <Skeleton animation="wave" variant="text" className="h-40 w-full" />
    </div>
  )
}

Loader.propTypes = {
  className: PropTypes.string,
}

export default Loader
